import React, { useContext, useEffect } from 'react';
import { Redirect, Route, useLocation } from 'react-router-dom';

import { useAuth } from 'contexts/AuthContext';
import { UserContext } from 'contexts/UserContext';

import { BulkBundlesUpload, CreateList, FAQs, Lists, ManageSubscriptions, Orders } from '../pages';
import { Header } from '../shared';

import './app.css';

function FamApp() {
    const location = useLocation();
    const { authStatus } = useAuth();
    const { roles, user } = useContext(UserContext);
    const isAuthenticating = authStatus === 'configuring';
    const isAuthenticated = authStatus === 'authenticated';

    useEffect(() => {
        if (location.pathname === '/' && roles.length) {
            const roleNames = roles.map((role) => role.name);
            if (roleNames.includes('VIEW_IMPORTED_ORDERS')) {
                window.location.href = '/lettuce/partners/orders';
            } else if (roleNames.includes('VIEW_CURATED_LISTS')) {
                window.location.href = '/lettuce/partners/lists';
            }
        }
    }, [location.pathname, roles]);

    if (!isAuthenticated && !isAuthenticating) {
        return <Redirect to={{ pathname: '/login', state: { from: location } }} />;
    }

    if (isAuthenticating) {
        return <div className="flex h-screen w-full items-center justify-center">Loading...</div>;
    }

    return (
        <div className="fam-app">
            {/* <BrowserRouter> */}
            <Header />
            {!!user.id && (
                <>
                    <Route path="/partners/lists">
                        <Lists />
                    </Route>
                    <Route path="/partners/orders">
                        <Orders />
                    </Route>
                    <Route path="/partners/create-list">
                        <CreateList />
                    </Route>
                    <Route path="/partners/subscriptions">
                        <ManageSubscriptions />
                    </Route>
                    <Route path="/partners/bundles/bulk-upload">
                        <BulkBundlesUpload />
                    </Route>
                    <Route path="/partners/faq">
                        <FAQs />
                    </Route>
                </>
            )}
            {/* <Route path="/partners/login">
                <Login />
            </Route> */}
            {/* </BrowserRouter> */}
        </div>
    );
}

export default FamApp;
